module.exports = __webpack_public_path__ + "static/media/frameSizeMenu.981e2001.png";